import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./CommonJquery/ScrollToTop";
import Dashbord from "./Components/Pages/Dashbord";
import Stations from "./Components/Pages/Stations";
import Timetables from "./Components/Pages/Timetables";
import FareManagement from "./Components/Pages/FareManagement";
import StationRoutes from "./Components/Pages/StationRoutes";
import Lines from "./Components/Pages/Lines";
import AddStations from "./Components/Pages/AddStations";
import Settings from "./Components/Pages/Settings";
import AddRoute from "./Components/Pages/AddRoute"
import AddFare from "./Components/Pages/AddFare";
import AddStaff from "./Components/Pages/AddStaff";
import Login from "./Components/Pages/Login";
import ImageDashboardAdd from "./Components/Pages/ImageDashboardAdd";
import ImageDashboardView from "./Components/Pages/ImageDashboardView";
import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";

function App() {
  // useEffect(() => {
  //   const lenis = new Lenis({
  //     duration: 1.2,
  //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //     smooth: true,
  //     direction: "vertical",
  //     gestureDirection: "vertical",
  //     smoothTouch: false,
  //     touchMultiplier: 2,
  //   });

  //   function raf(time) {
  //     lenis.raf(time);
  //     requestAnimationFrame(raf);
  //   }

  //   requestAnimationFrame(raf);

  //   return () => {
  //     lenis.destroy();
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashbord />} />
          <Route path="/stations" element={<Stations />} />
          <Route path="/add-stations" element={<AddStations />} />
          <Route path="/edit-stations/:station_id" element={<AddStations />} />
          <Route path="/timetables" element={<Timetables />} />
          <Route path="/fares" element={<FareManagement />} />
          <Route path="/routes/:line_id" element={<StationRoutes />} />
          <Route path="/lines" element={<Lines />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/add-route/:line_id" element={<AddRoute />} />
          <Route path="/edit-route/:line_id/:primary_id" element={<AddRoute />} />
          <Route path="/add-fare" element={<AddFare />} />
          <Route path="/add-staff" element={<AddStaff />} />
          <Route path="/add-silder" element={<ImageDashboardAdd />} />
          <Route path="/imageDashboardView" element={<ImageDashboardView />} />
          <Route path="/ImageDashboardEdit/:id" element={<ImageDashboardAdd />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
